import { normalizeNumber } from '../formatters';

export default function isPhone(value) {
  if (!value) {
    return false;
  }

  const cel = normalizeNumber(value);
  return !(!cel || cel.length < 10);
}
